import { GUI } from "dat.gui";
import { Mesh, TextureLoader } from "three";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";
import { imgsTopicThree } from "../../../../../assets/activityes/topicthreeActvone";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/subtopicthree/GLB_Monitor_V4.glb";

export class Monitor extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.listenersobserver();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Monitor = gltf.scene.getObjectByName("Monitor", true);
			this.Pantalla = gltf.scene.getObjectByName("Pantalla", true);
			this.Plano = gltf.scene.getObjectByName("Plano", true);
			this.initMonitor();
		});
	}

	updateMaterialScreen(img) {
		const newTexture = new TextureLoader().load(img);
		const object = this.Plano;
		object.material.map = newTexture
		object.material.toneMapped = false;
	}

	listenersobserver() {
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.viewMonitor.img2, () => {
			this.updateMaterialScreen(imgsTopicThree.screeenTwo);
		});
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.viewMonitor.img3, () => {
			this.updateMaterialScreen(imgsTopicThree.screenThree);
		});
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.viewMonitor.img4, () => {
			this.updateMaterialScreen(imgsTopicThree.screenFour);
		});
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.viewMonitor.img5, () => {
			this.updateMaterialScreen(imgsTopicThree.screenfive);
		});
		ObserverEmitter.on(EVENTS.subtopicThree.activityone.viewMonitor.show, () => {
			this.visible = true;
		});
	}

	initMonitor() {
		this.position.set(-11.1173, -0.2039, 1.2276);
		this.scale.set(2, 2);
		this.Pantalla.scale.set(0.7523, 1, 1) // monitor cuadrado
		this.updateMaterialScreen(imgsTopicThree.screeenOne);
	}

	helpersChild() {
		// this.helpersMethod("Base monitor", this.Monitor);
		// this.helpersMethod("monitor pantalla", this.Pantalla);
		this.helpersMethod("monitor plano", this.Plano);
	}

	loadNewTexture(object) {
		const fileInput = document.createElement("input");
		fileInput.type = "file";
		fileInput.accept = "image/*";

		fileInput.addEventListener("change", function (event) {
			const file = event.target.files[0];
			if (file) {
				const reader = new FileReader();
				reader.onload = function (e) {
					const newTexture = new TextureLoader().load(e.target.result);
					object.material.map = newTexture;
					object.material.toneMapped = false;
				};
				reader.readAsDataURL(file);
			}
		});

		fileInput.click();
	}

	helpersMethod(name = "", object) {
		const { scale, position, rotation, material } = object;
		const gui = new GUI();
		const folderMostrador = gui.addFolder(name);
		const limit = 20;
		folderMostrador.add(scale, "x", -limit, limit).step(0.0001).name("Scala x");
		folderMostrador.add(scale, "y", -limit, limit).step(0.0001).name("Scala y");
		folderMostrador.add(scale, "z", -limit, limit).step(0.0001).name("Scala Z");

		folderMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(object, "visible").name("Visible");

		folderMostrador
			.addColor({ color: material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				material.color.set(value);
			});

		folderMostrador.add({ loadTexture: () => this.loadNewTexture(object) }, "loadTexture").name("Cargar Textura");

		if (object.material.type !== "MeshBasicMaterial") {
			folderMostrador.add(object.material, "lightMapIntensity", 0, 5).name("Intensidad del mapa de luz");
			folderMostrador.add(object.material, "emissiveIntensity", 0, 5).name("Emesidad del mapa de luz");
		}

		folderMostrador.add(object.material.map.repeat, "x", -5, 5).step(0.01).name("Repetición X");
		folderMostrador.add(object.material.map.repeat, "y", -5, 5).step(0.01).name("Repetición Y");
	}

	helpers() {
		const gui = new GUI();
		const folderMostrador = gui.addFolder("Monitor");
		const limit = 20;
		folderMostrador.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(this, "visible").name("Visible");

		folderMostrador
			.addColor({ color: this.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				this.material.color.set(value);
			});
		// folderMostrador.add(this.material, "lightMapIntensity", 0, 5).name("Intensidad del mapa de luz");
		// folderMostrador.add(this.material.map.repeat, "y", -1, 1).step(0.01).name("Repetición Y del mapa de textura");
	}
}
